define([
    "skylark-router/router"
], function(router) {
    return router;
});
